// extracted by mini-css-extract-plugin
module.exports = {"divider":"HorizontalDivider_divider__4dyFh","explaining":"HorizontalDivider_explaining__Z66v5","longform":"HorizontalDivider_longform__gW2m5"};